<template>
<a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="openDrawer" @close="onClose">
<!--  <page-header-wrapper>-->
    <a-card :bordered="false">
      <a-divider orientation="left">
        <b>订单详情</b>
      </a-divider>
      <a-form-model ref="form" :model="form">
        <a-form-model-item label="订单编号" prop="id">
          <a-input disabled v-model="form.id" placeholder="请输入订单编号" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <span v-if="form.status == 0">待支付</span>
          <span v-if="form.status == 1">已支付</span>
          <span v-if="form.status == 2">已发货</span>
          <span v-if="form.status == 3">已完成</span>
          <span v-if="form.status == 4">已售后</span>
          <span v-if="form.status == 5">待评价</span>
          <span v-if="form.status == -1">已取消</span>
        </a-form-model-item>
        <a-form-model-item label="推送失败原因:" v-if="types == 3">
          <a-input disabled style="width: 100%" v-model="form.cause" :min="0" :max="100" />
        </a-form-model-item>
        <a-form-model-item label="总金额" prop="totalAmount">
          <a-input disabled v-model="form.totalAmount" placeholder="请输入总金额" />
        </a-form-model-item>
        <!--      <a-form-model-item label="优惠金额" prop="discountAmount" >-->
        <!--        <a-input v-model="form.discountAmount" placeholder="请输入优惠金额" />-->
        <!--      </a-form-model-item>-->
        <a-form-model-item label="用户姓名" prop="nickname">
          <a-input disabled v-model="form.nickname" placeholder="请输入用户ID" />
        </a-form-model-item>
        <a-form-model-item label="支付金额" prop="payAmount">
          <a-input disabled v-model="form.payAmount" placeholder="请输入支付金额" />
        </a-form-model-item>
        <!--      <a-form-model-item label="消耗积分数" prop="reduceScores" v-if="form.type == 1">-->
        <!--        <a-input disabled v-model="form.reduceScores" placeholder="请输入消耗积分数" />-->
        <!--      </a-form-model-item>-->
        <a-form-model-item label="消耗现金券额度" prop="reduceVoucher" v-if="types == 1 || types == 2">
          <a-input disabled v-model="form.reduceVoucher" placeholder="请输入消耗现金券额度" />
        </a-form-model-item>
        <a-form-model-item label="运费" prop="freightAmount">
          <a-input disabled v-model="form.freightAmount" placeholder="请输入运费" />
        </a-form-model-item>
        <a-form-model-item label="支付方式" prop="payType" v-if="form.status != -1 && form.status != 0">
          <span v-if="form.payType == 0">余额</span>
          <span v-if="form.payType == 1">PayPal</span>
          <span v-if="form.payType == 2">支付宝</span>
        </a-form-model-item>
        <a-form-model-item label="支付时间" prop="payTime" v-if="form.status != -1 && form.status != 0">
          <a-date-picker disabled style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear />
        </a-form-model-item>
        <a-form-model-item label="收货地址" prop="address">
          <a-button
            v-clipboard:copy="form.address"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            v-if="types == 2"
            >复制</a-button
          >

          <a-input disabled v-model="form.address" placeholder="" />
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-card :bordered="false">
      <div class="table-operations">
        <a-button
          type="primary"
          v-if="types == 2 || types == 3"
          :disabled="multiple"
          @click="openDeliver"
          v-hasPermi="['orderItem:orderItem:edit']"
        >
          <a-icon type="edit" />发货
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <a-modal :visible="open" :width="500" @ok="submitDeliver" @cancel="cancelDeliver">
        <a-divider orientation="left">
          <b>批量发货</b>
        </a-divider>
        <a-form-model ref="delivererForm" :model="delivererForm" :rules="rules">
          <a-form-model-item label="物流公司" prop="logisticsCompany">
            <a-input v-model="delivererForm.logisticsCompany" placeholder="请输入物流公司" />
          </a-form-model-item>
          <a-form-model-item label="物流单号" prop="logisticsNumber">
            <a-input v-model="delivererForm.logisticsNumber" placeholder="请输入物流单号" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 增加修改 -->

      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :scroll="{ x: 1500, y: 'calc(100vh - 300px)' }"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: getCheckboxProps,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.image"
            :src="record.image"
            preview="头像"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            v-if="record.status == 1 && types == 2"
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['orderItem:orderItem:edit']"
          >
            <a-icon type="edit" />发货
          </a>
          <a v-else @click="$refs.createForm.handleInfo(record)" v-hasPermi="['orderItem:orderItem:query']">
            <a-icon type="file" />详情
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
<!--  </page-header-wrapper>-->
</a-drawer>
</template>

<script>
import { pageOrderItem, listOrderItem, delOrderItem, bathDeliver } from '@/api/orderItem/orderItem'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { getOrderOrder } from '@/api/order/order'

export default {
  name: 'OrderItem',
  components: {
    CreateForm,
  },
  // props: ['orderId'],
  mixins: [tableMixin],
  data() {
    return {
      types: -1,
      list: [],
      // 是否可以发货
      isStatus: 0,
      selectedRowKeys: [],
      selectedRows: [],
      delivererForm: {
        logisticsCompany: null,
        logisticsNumber: null,
        ids: [],
      },
      open: false,
      openDrawer:false,
      form: {
        id: null,
        type: null,
        status: 0,
        totalAmount: null,
        discountAmount: null,
        nickname: null,
        payAmount: null,
        reduceScores: null,
        reduceVoucher: null,
        freightAmount: null,
        payType: null,
        payTime: null,
        address: null,
        logisticsCompany: null,
        logisticsNumber: null,
        createTime: null,
        remark: null,
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        orderId: null,
        status: null,
        payMethod: null,
        payTime: null,
        payType: null,
        productId: null,
        quantity: null,
        productName: null,
        skuId: null,
        skuName: null,
        price: null,
        image: null,
        reduceVoucher: null,
        reduceScores: null,
        freight: null,
        logisticsCompany: null,
        logisticsNumber: null,
        pageNum: 1,
        pageSize: 10,
      },
      rules: {
        logisticsCompany: [{ required: true, message: '物流公司不能为空', trigger: 'blur' }],
        logisticsNumber: [{ required: true, message: '物流单号不能为空', trigger: 'blur' }],
      },
      columns: [
        // {
        //   title: '订单项ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '订单编号',
          dataIndex: 'orderId',
          // ellipsis: true,
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f) {
            if (f == 0) {
              return '待支付'
            } else if (f == 1) {
              return '已支付'
            } else if (f == 2) {
              return '已发货'
            } else if (f == 3) {
              return '已完成'
            } else if (f == 4) {
              return '已售后'
            } else if (f == 5) {
              return '待评价'
            } else if (f == -1) {
              return '已取消'
            } else if (f == 7) {
              return '交易关闭'
            }
          },
        },
        // {
        //   title: '支付时间',
        //   dataIndex: 'payTime',
        //   scopedSlots: { customRender: 'payTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '支付类型',
        //   dataIndex: 'payType',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f ==1){
        //       return '微信'
        //     }else if(f ==2){
        //       return '支付宝'
        //     }else{
        //       return '余额'
        //     }
        //   }
        // },
        {
          title: '商品数量',
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '规格名称',
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '价格',
          dataIndex: 'price',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '商品图片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'image' },
        },
        {
          title: '消耗现金券数量',
          dataIndex: 'reduceVoucher',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '消耗积分数',
        //   dataIndex: 'reduceScores',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '运费',
        //   dataIndex: 'freight',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '物流公司',
          dataIndex: 'logisticsCompany',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '物流单号',
          dataIndex: 'logisticsNumber',
          // ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   // ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  // created () {
  //   this.queryParam.orderId = this.orderId
  //   this.getOrderInfo()
  //   this.getList()
  // },
  mounted() {
    // this.queryParam.orderId = this.orderId
    // this.getOrderInfo(this.orderId)
    // this.getList()
  },
  // activated() {

  // },
  computed: {},
  watch: {},
  methods: {
    // handleWatch(row) {
    //   this.reset()
    //   this.formType = 2
    //   const id = row ? row.id : row.id
    //   getOrderOrder({ id: id }).then((response) => {
    //     this.form = response.data
    //     this.open = true
    //     this.formTitle = '订单详情'
    //   })
    // },
    onCopy(e) {
      this.$message.success('内容已复制到剪切板！')
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error('抱歉，复制失败！')
    },
    /** 查询订单项列表 */
    getList() {
      this.loading = true
      this.list = []
      this.total = 0
      this.current = 0
      this.size = 0
      pageOrderItem(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    cancel() {
      this.open = false
      this.reset()
    },

    cancelDeliver() {
      this.resetDeliver()
      this.open = false
    },
    submitDeliver() {
      this.$refs.delivererForm.validate((valid) => {
        if (valid) {
          bathDeliver(this.delivererForm).then((res) => {
            if (res.success) {
              this.$message.success('操作成功')
              this.cancelDeliver()
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    openDeliver() {
      this.resetDeliver()
      this.delivererForm.ids = this.ids
      if (this.types == 2) {
        this.open = true
        this.delivererForm.ids = this.ids
      } else {
        bathDeliver(this.delivererForm).then((res) => {
          if (res.success) {
            this.$message.success('操作成功')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    resetDeliver() {
      this.delivererForm = {
        logisticsCompany: null,
        logisticsNumber: null,
        ids: [],
      }
      this.$nextTick(() => {
        if (this.$refs.delivererForm) {
          this.$refs.delivererForm.resetFields()
        }
      })
    },
    // 表单重置
    reset() {
      this.orderId = null
      this.form = {
        id: null,
        type: null,
        orderNo: null,
        status: 0,
        totalAmount: null,
        discountAmount: null,
        nickname: null,
        payAmount: null,
        reduceScores: null,
        reduceVoucher: null,
        freightAmount: null,
        payType: null,
        payTime: null,
        quantity: null,
        address: null,
        logisticsCompany: null,
        logisticsNumber: null,
        createTime: null,
        orderItemList: [],
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },

    getOrderInfo(id, type) {
      this.reset()
      // detail
      this.types = type
      this.queryParam.orderId = id
      getOrderOrder({ id: id }).then((response) => {

        this.form = response.data

      })
      this.getList()
      this.openDrawer = true
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        orderId: undefined,
        status: undefined,
        payMethod: undefined,
        payTime: undefined,
        payType: undefined,
        productId: undefined,
        quantity: undefined,
        productName: undefined,
        skuId: undefined,
        skuName: undefined,
        price: undefined,
        image: undefined,
        reduceVoucher: undefined,
        reduceScores: undefined,
        freight: undefined,
        logisticsCompany: undefined,
        logisticsNumber: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    getCheckboxProps: (record) => ({
      props: {
        disabled: record.status != 1, // Column configuration not to be checked
        // name: record.name,
      },
    }),
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.selectedRows.forEach((item) => {
        if (item.status != 1) {
          this.$message.error('编号:' + item.id + '已发货，请勿重复发货')
          this.isStatus = 1
          return
        }
      })
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delOrderItem(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'orderItem/orderItem/export',
            {
              ...that.queryParam,
            },
            `订单项_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    onClose() {
      this.openDrawer = false
    },
  },
}
</script>
